import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';
import { Router } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { InlineSvgComponent } from '../inline-svg/inline-svg.component';
import { MatDialog } from '@angular/material/dialog';
import { UserSelectDialogComponent } from '../../user-select-dialog.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'frmg-main-vertical-menubar-left',
  templateUrl: './main-vertical-menubar-left.component.html',
  styleUrls: ['./main-vertical-menubar-left.component.scss'],
  imports: [MatTooltip, NgClass, InlineSvgComponent]
})
export class MainVerticalMenubarLeftComponent implements OnInit, OnDestroy {
  @Output() toggleRequest: EventEmitter<string> = new EventEmitter<string>();

  @Input() showNotification!: boolean;
  @Input() totalUnreadNotifications!: number;
  @Output() showNotificationChange = new EventEmitter<boolean>();


  constructor(
    private cd: ChangeDetectorRef,
    public router: Router,
    private settingsService: SettingsService,
    private dialog: MatDialog
  ) {

  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {

  }

  public navigate(url: string) {
    if (this.showNotification) {
      this.hideNotification();
    }
    this.router.navigate([`/${url}`]);
  }


  openNotifications(): void {
    this.showNotification = !this.showNotification;
    this.showNotificationChange.emit(this.showNotification);
    this.cd.detectChanges();
  }

  hideNotification() {
    if (this.showNotification) {
      this.openNotifications();
    }
  }

  logout(): void {
    this.showNotification = false;
    this.showNotificationChange.emit(this.showNotification);
    this.settingsService.logout();
  }

  public openUserSwap() {
    const dialogRef = this.dialog.open(UserSelectDialogComponent, {
      width: '300px'
    });
    dialogRef.afterClosed().subscribe(_ => {
      window.location.reload();
    });
  }

  protected readonly environment = environment;
}
